/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateHomeWorkspaceRequest
 */
export interface CreateHomeWorkspaceRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateHomeWorkspaceRequest
     */
    volume: number;
}

export function CreateHomeWorkspaceRequestFromJSON(json: any): CreateHomeWorkspaceRequest {
    return CreateHomeWorkspaceRequestFromJSONTyped(json, false);
}

export function CreateHomeWorkspaceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHomeWorkspaceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'volume': json['volume'],
    };
}

export function CreateHomeWorkspaceRequestToJSON(value?: CreateHomeWorkspaceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'volume': value.volume,
    };
}


